import { render } from "./remaining.vue?vue&type=template&id=a764447e&scoped=true"
import script from "./remaining.vue?vue&type=script&lang=js"
export * from "./remaining.vue?vue&type=script&lang=js"

import "./remaining.vue?vue&type=style&index=0&id=a764447e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a764447e"]])

export default __exports__